import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptor } from './core/interceptors/auth-interceptor.service';
import { LoaderService } from './core/interceptors/loader.service';
import { BalanceService } from './core/services/balance.service';
import { CommonDataService } from './core/services/common-data.service';
import { CommonStorageService } from './core/services/common-storage.service';
import { CustomFilterService } from './core/services/custom-filter.service';
import { DataLaerService } from './core/services/data-laer.service';
import { ErrorHandlerService } from './core/services/error-handler.service';
import { ExportService } from './core/services/export.service';
import { HttpHeadersService } from './core/services/http-headers.service';
import { HubLevelService } from './core/services/hub-level.service';
import { InteractionService } from './core/services/interaction.service';
import { LoginService } from './core/services/login.service';
import { NotificationService } from './core/services/notification.service';
import { OrganisationService } from './core/services/organisation.service';
import { PartnerOutageService } from './core/services/partner-outage.service';
import { RegServiceService } from './core/services/reg-service.service';
import { RolesService } from './core/services/roles.service';
import { SettingsService } from './core/services/settings.service';
import { TransactionBalanceFilterService } from './core/services/transaction-balance-filter.service';
import { TransactionsService } from './core/services/transactions.service';
import { TwofactorAuthenticationService } from './core/services/twofactor-authentication.service';
import { UnderConstructionService } from './core/services/under-construction.service';
import { UserService } from './core/services/user.service';
import { UtilService } from './core/services/util.service';
import { WindowReferenceService } from './core/services/window-reference.service';
import { OnafriqModule } from './shared/onafriq.module';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, BrowserAnimationsModule, SharedModule, AppRoutingModule, HttpClientModule, OnafriqModule],
  providers: [
    LoginService,
    HttpHeadersService,
    TwofactorAuthenticationService,
    PartnerOutageService,
    ErrorHandlerService,
    DataLaerService,
    ExportService,
    WindowReferenceService,
    RolesService,
    CustomFilterService,
    CommonStorageService,
    RegServiceService,
    NotificationService,
    UnderConstructionService,
    TransactionsService,
    BalanceService,
    CommonDataService,
    UtilService,
    OrganisationService,
    InteractionService,
    TransactionBalanceFilterService,
    HubLevelService,
    SettingsService,
    LoaderService,
    UserService,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    // {
    //   provide: 'AuthService',
    //   useClass: environment.mockAuthentication ? MockAuthService : AuthService,
    // },
  ],
  exports: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
